import qs from 'qs';

export class DocumentsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDocumentById({ documentId, ...params }) {
    // Repeat-style array serialization (include=A&include=B) — the backend binds
    // multiple includes (e.g. ExtractionRequest + ExtractionSessions) from repeated keys.
    return this.#http.get(`/api/documents/${documentId}`, {
      params,
      paramsSerializer: {
        serialize: serializeParams =>
          qs.stringify(serializeParams, { arrayFormat: 'repeat', encode: false }),
      },
    });
  }

  /**
   * GET /api/documents — filter documents by type and metadata (e.g. `ApplicationId:<id>`).
   */
  async findDocuments({ typeId, metadata, isDeleted = false }) {
    return this.#http.get('/api/documents', {
      params: { typeId, metadata, isDeleted },
    });
  }

  async uploadDocument(body) {
    return this.#http.post('/api/documents', body, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async editDocument(body) {
    return this.#http.put(`/api/documents/${body.id}`, body);
  }

  getContent = async ({ documentId, ...params }) => {
    return this.#http.get(`/api/documents/${documentId}/content`, {
      params: {
        isUserView: true,
        ...params,
      },
      responseType: 'blob',
    });
  };

  async editContent({ documentId, formData }) {
    return this.#http.put(`/api/documents/${documentId}/content`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async restoreDocument({ documentId }) {
    return this.#http.put(`/api/documents/${documentId}/restore`);
  }

  async getAiExtractionResult({ documentId }) {
    return this.#http.get(`/api/documents/${documentId}/ai-analysis-result`);
  }

  async getExtractionFilledFields({ documentId, ...params }) {
    return this.#http.get(`/api/documents/${documentId}/extraction-request/status/results`, {
      params,
      paramsSerializer: {
        serialize: params => qs.stringify(params, { arrayFormat: 'repeat', encode: false }),
      },
    });
  }

  async getDocumentAssociations({ documentId }) {
    return this.#http.get(`/api/documents/${documentId}/associations`);
  }

  /**
   * PUT /api/documents/{id}/associations
   * Accepts the collection-contract shape: { borrowerIds[], incomeIds[], assetIds[], ... }
   * Skynet.Documents #393
   */
  async editDocumentAssociations(body) {
    return this.#http.put(`/api/documents/${body.documentId}/associations`, body);
  }

  async rerunExtraction({ documentId }) {
    return this.#http.post(`/api/documents/${documentId}/extraction-request`);
  }
}
